import { Head } from 'arcway/lib/client';
import { DocumentationIndex } from '#components/documentation.jsx';
export default function DocsPage({
  articles
}) {
  return <>
      <Head description='Guides for creating, publishing, distributing, and managing a podcast with Mono.' title='Documentation — mono.fm' />
      <DocumentationIndex articles={articles} />
    </>;
}